import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import Button from '@helsenorge/designsystem-react/components/Button';
import Close from '@helsenorge/designsystem-react/components/Close';
import Input from '@helsenorge/designsystem-react/components/Input';
import { usePseudoClasses } from '@helsenorge/designsystem-react/hooks/usePseudoClasses';
import { isMutableRefObject, mergeRefs } from '@helsenorge/designsystem-react/utils/refs';
import { useResourcesContext } from './resources';
import styles from './styles.module.scss';
const FilterSearch = React.forwardRef((props, ref) => {
    const { classNames, disabled, onChange, defaultValue } = props;
    const resources = useResourcesContext();
    const { refObject } = usePseudoClasses(isMutableRefObject(ref) ? ref : null);
    const mergedRefs = mergeRefs([ref, refObject]);
    const containerClassNames = cn(styles['filter-sok-container'], classNames);
    const clearSearchText = () => {
        if (refObject && refObject.current) {
            refObject.current.value = '';
            onChange?.({ target: { value: '' } });
        }
    };
    const handleKeydown = event => {
        if (event.key === 'Enter' && props.onSearch) {
            props.onSearch();
        }
    };
    return (_jsxs("div", { className: containerClassNames, children: [_jsx("div", { className: styles['filter-sok-container__input'], children: _jsx(Input, { label: resources.searchLabel, disabled: disabled, onChange: onChange, onKeyDown: handleKeydown, ref: mergedRefs, defaultValue: defaultValue, rightOfInput: refObject?.current?.value && (_jsx("div", { className: styles['filter-sok-container__clear-button'], children: _jsx(Close, { small: true, ariaLabel: resources.resetSearchInputAriaLabel, onClick: clearSearchText }) })) }) }), props.onSearch && (_jsx(Button, { disabled: disabled, wrapperClassName: styles['filter-sok-container__button'], onClick: props.onSearch, children: resources.searchButtonText }))] }));
});
FilterSearch.displayName = 'FilterSearch';
export default FilterSearch;
